import { render, staticRenderFns } from "./CrudIdeaForm.vue?vue&type=template&id=5ab05aa1&"
import script from "./CrudIdeaForm.vue?vue&type=script&lang=js&"
export * from "./CrudIdeaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports